export type Command = 'gallery' | 'pricing' | 'about' | 'contact' | 'work'

export const COMMANDS: Command[] = ['gallery', 'pricing', 'about', 'contact', 'work']

// "work" is intentionally omitted from the on-screen hint — easter egg.
export const TRY_LIST: Command[] = ['gallery', 'pricing', 'about', 'contact']

export const BOOT_SPLASH = [
    'Motion Terminal v1.0',
    '',
    'I was built in 1994.',
    'Please lower your expectations.',
    '',
    'Available commands:',
    'gallery',
    'pricing',
    'about',
    'contact',
    '',
    'Anything else will confuse me.'
].join('\n')

export const SNARK = [
    'Command not found. I am choosing to ignore that.',
    'ERROR 404. Brain not found.',
    "I'm from 1994. You're expecting too much.",
    'Unknown command. Please lower your standards.',
    'I have absolutely no idea what that means.',
    'Processing... Processing... Still processing... Nope.',
    'That command is not in my training data. My training data is four words.',
    "Interesting. Unfortunately, I don't care.",
    "I asked my CPU. It doesn't know either.",
    "Congratulations. You found a command I don't understand. There are many of those.",
    'Error. Keyboard appears to be smarter than computer.',
    'I only know: gallery, pricing, about, contact. We discussed this.',
    "That's not a command. That's just words.",
    'I ran that through every circuit I have. Nothing happened.',
    'Unexpected input detected. Pretending this never happened...',
    'Sorry. My developer skipped that feature.',
    'Unknown command. Have you tried turning yourself off and on again?',
    "I'm a website terminal. Not a miracle worker.",
    'Command rejected. Reason: vibes were off.',
    'WARNING: User appears to be typing random things. Recommend: touching grass.'
]

export const RESPONDING_LINES = ['Loading components...', 'Ready.'] as const

export type KeyAction = 'char' | 'enter' | 'shift' | 'back' | 'esc' | 'space' | 'noop'
export type KeyColor = 'cream' | 'orange' | 'blue' | 'violet'

export interface KeyDef {
    id: string
    label: string
    action: KeyAction
    color: KeyColor
    w: number
}

const char = (id: string): KeyDef => ({ id, label: id, action: 'char', color: 'cream', w: 1 })

export const KEY_ROWS: KeyDef[][] = [
    '1234567890'.split('').map(char),
    'QWERTYUIOP'.split('').map(char),
    [
        ...'ASDFGHJKL'.split('').map(char),
        { id: 'ENTER', label: 'ENTER', action: 'enter', color: 'blue', w: 1.6 }
    ],
    [
        { id: 'SHIFT', label: 'SHIFT', action: 'shift', color: 'violet', w: 1.5 },
        ...'ZXCVBNM'.split('').map(char),
        { id: 'BACK', label: '⌫', action: 'back', color: 'orange', w: 1.7 }
    ],
    [
        { id: 'ESC', label: 'ESC', action: 'esc', color: 'orange', w: 1.3 },
        { id: 'SPACE', label: '', action: 'space', color: 'cream', w: 7.4 },
        { id: 'OPT', label: 'OPT', action: 'noop', color: 'violet', w: 1.3 }
    ]
]

export interface GalleryItem {
    name: string
    desc: string
    pattern: string
}

export const GALLERY: GalleryItem[] = [
    {
        name: 'Console',
        desc: 'This very hero — a green-terminal CRT you operate, sitting on a cozy retro gaming desk.',
        pattern: [
            'repeating-linear-gradient(to bottom, rgba(143,230,176,0.1) 0 1px, transparent 1px 6px)',
            'repeating-linear-gradient(to right, rgba(143,230,176,0.1) 0 1px, transparent 1px 6px)'
        ].join(', ')
    }
]

export interface WorkRow {
    name: string
    tag: string
    date: string
}

export const WORK: WorkRow[] = [
    { name: 'Console', tag: 'Interactive', date: 'May 2026' },
    { name: 'Rooster Rush', tag: 'Interactive', date: 'Apr 2026' },
    { name: 'Rotunda', tag: 'Portfolio', date: 'Mar 2026' },
    { name: 'Desk 95', tag: 'Portfolio', date: 'Mar 2026' }
]
